<template>
  <v-card class="elevation-0 ma-8 px-2 py-6">
    <v-card-title>
        Platillos
        <v-spacer></v-spacer>
        <v-text-field
            @keydown.enter="getDataFromApi()"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            class="mb-6 mx-4"
        ></v-text-field>
    </v-card-title>
    
    <v-data-table
        show-expand
        :items="foods" 
        :headers="header"
        :footer-props="{'items-per-page-options':[15, 30, 50, totalFoods]}"
        :options.sync="options"
        :server-items-length="totalFoods"
        :loading="loading"
        class="px-6"
    >
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
                <v-data-table
                    :items="item.food" 
                    :headers="[
                        {text:'Alimento', value:'name'}
                    ]"
                    class="pa-6"
                    style="background:transparent;"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list style="font-size:13px;">
                                <v-list-item @click="edited_item = item, editDialog = true">
                                    <v-icon small class="mr-2">
                                        mdi-pencil
                                    </v-icon>
                                    Editar
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </td>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list style="font-size:13px;">
                    <v-list-item @click="edited_item = item, editDialog = true">
                        <v-icon small class="mr-2">
                            mdi-pencil
                        </v-icon>
                        Editar
                    </v-list-item>
                </v-list>
                <v-list style="font-size:13px;">
                    <v-list-item @click="edited_item = item, confirm_delete = true">
                        <v-icon small class="mr-2">
                            mdi-delete
                        </v-icon>
                        Eliminar
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-data-table>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
    <!-- Crear alimento -->
    <v-dialog v-model="createDialog" max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn bottom color="#e12826" dark fab fixed right v-bind="attrs" v-on="on">
            <v-icon color="white">  mdi-plus </v-icon>
        </v-btn> 
      </template>
      <create @closeCreateDialog="closeCreateDialog"/>
    </v-dialog>
    <!-- editar alimento -->
    <v-dialog v-model="editDialog" max-width="700px">
      <edit v-bind:food="edited_item" @closeEditDialog="closeEditDialog"/>
    </v-dialog>

    
    <div class="text-center">
      <v-bottom-sheet  v-model="confirm_delete" inset>
        <v-sheet class="text-center" height="150px">
          <div class="pt-6">
          ¿Seguro que deseas borrar el platillo <strong>{{edited_item.name}}</strong>?
          </div>
          <v-btn class="mt-4" text color="error" @click="deleteDish()">
          Eliminar
          </v-btn>
          <v-btn class="mt-4" text color="grey" @click="edited_item={}, confirm_delete=false">
          Cancelar
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
import Create from './create.vue'
import Edit from './edit.vue'
import axios from "axios"
  export default {
    components:{
      'create': Create,
      'edit':Edit
    },
    data () {
      return {
        confirm_delete:false,
        edited_item:{},
        editDialog:false,
        createDialog:false,
        editDialog: false,
        totalFoods: 0,
        foods: [],
        loading: true,
        options: {},
        activeSearch: false,
        search: '',
        header: [
            { text: '', value: 'data-table-expand' },
            {text:'Platillo', value:'name'},
            {value:'actions', sortable:false},
        ],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
      }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods:{
        deleteDish(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/food_dishes/" + this.edited_item.id).then(response => {
                this.confirm_delete = false
                this.edited_item = undefined
                this.getDataFromApi()
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.foods = data.foods
                this.totalFoods = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var foods = []
                var total = 0
                var link = ''
                if(sortBy.length === 1){
                    if(sortDesc[0]){
                        link = link + "sort=-" + sortBy[0] + '&'
                    }else{
                        link = link + "sort=" + sortBy[0] + '&'
                    }
                }
                if(this.search!=''){
                    link = link + 'filter[name]=' + this.search + '&'
                }
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/food_dishes?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage).then(response => {
                    const resp = response.data
                    foods = this.mapFoods(resp)
                    total = resp.meta.total
                    resolve({
                        foods,
                        total,
                    })
                })
            })
        },
        mapFoods(items){
            return items.data
            return items.filter(objeto => !("header" in objeto) && !("divider" in objeto));
        },
        closeCreateDialog: function(params){
            this.getDataFromApi()
            this.createDialog = params
        },
        closeEditDialog: function(params){
            this.getDataFromApi()
            this.editDialog = params
        }
    }
}
</script>

<style >
    .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    }
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #eeeeee75;
    }
</style>